import React from "react";
import { gql, useQuery } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import TableLink from "../TableLink";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Grid
} from "@material-ui/core";
import { useParams } from "react-router-dom";

const styles = theme => ({
  root: {
    marginTop: theme.spacing(3),
    overflowX: "auto",
    margin: "auto"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 300
  },
  totalsCell: {
    fontWeight: "bold"
  }
});

const GET_TOURNAMENT_GAMES = gql`
  query gameDetailQuery($id: Int, $gameId: Int) {
    Game(
      id: $gameId
      filter: { round: { tournament: { id: $id } } }
      orderBy: round_number_asc
    ) {
      id
      scoreline
      team_performances {
        id
        team {
          id
          name
        }
        bonuses_heard
        bonus_points
        player_performances {
          id
          player {
            id
            name
          }
          powers
          gets
          negs
          points
        }
      }
    }
  }
`;

function GameDetail(props) {
  const { id, gameId } = useParams();
  const { classes } = props;

  const { loading, data, error } = useQuery(GET_TOURNAMENT_GAMES, {
    variables: {
      id: parseInt(id),
      gameId: parseInt(gameId) || undefined
    }
  });

  return (
    <div className={classes.root}>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          {data.Game.map(g => {
            return (
              <React.Fragment key={g.id}>
                <Typography variant="h6" gutterBottom>
                  {g.scoreline}
                </Typography>
                <Grid container spacing={2}>
                  {g.team_performances.map(tp => {
                    return (
                      <Grid item key={tp.id} xs={6}>
                        <Table className={classes.table} size="small">
                          <colgroup>
                            <col style={{ width: "30%" }} />
                            <col style={{ width: "5%" }} />
                            <col style={{ width: "5%" }} />
                            <col style={{ width: "5%" }} />
                            <col style={{ width: "5%" }} />
                          </colgroup>
                          <TableHead>
                            <TableRow>
                              <TableCell key="player">
                                <TableLink
                                  to={`/tournament/${id}/team-detail/${tp.team.id}`}
                                >
                                  {tp.team.name}
                                </TableLink>
                              </TableCell>
                              <TableCell key="powers">Powers</TableCell>
                              <TableCell key="gets">Gets</TableCell>
                              <TableCell key="negs">Negs</TableCell>
                              <TableCell key="points">Points</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {tp.player_performances.map(p => {
                              return (
                                <TableRow key={p.id}>
                                  <TableCell component="th" scope="row">
                                    <TableLink
                                      to={`/tournament/${id}/individual-detail/${p.player.id}`}
                                    >
                                      {p.player.name}
                                    </TableLink>
                                  </TableCell>
                                  <TableCell>{p.powers}</TableCell>
                                  <TableCell>{p.gets}</TableCell>
                                  <TableCell>{p.negs}</TableCell>
                                  <TableCell>{p.points}</TableCell>
                                </TableRow>
                              );
                            })}
                            <TableRow key={`${tp.id}_footer`}>
                              <TableCell
                                className={classes.totalsCell}
                                component="th"
                                scope="row"
                              >
                                Totals
                              </TableCell>
                              <TableCell className={classes.totalsCell}>
                                {tp.player_performances.reduce(
                                  (total, current) =>
                                    total + (current.powers || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell className={classes.totalsCell}>
                                {tp.player_performances.reduce(
                                  (total, current) =>
                                    total + (current.gets || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell className={classes.totalsCell}>
                                {tp.player_performances.reduce(
                                  (total, current) =>
                                    total + (current.negs || 0),
                                  0
                                )}
                              </TableCell>
                              <TableCell className={classes.totalsCell}>
                                {tp.player_performances.reduce(
                                  (total, current) =>
                                    total + (current.points || 0),
                                  0
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                        <Typography variant="subtitle2" gutterBottom>
                          Bonuses Heard: {tp.bonuses_heard} Bonus Points:{" "}
                          {tp.bonus_points} PPB:{" "}
                          {tp.bonuses_heard
                            ? (tp.bonus_points / tp.bonuses_heard).toFixed(2)
                            : (0.0).toFixed(2)}
                        </Typography>
                      </Grid>
                    );
                  })}
                </Grid>
                <br />
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default withStyles(styles)(GameDetail);
